<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div class="tabs-container">
          <el-tabs ref="tabs" v-model="activeTabName" type="card" style="width: 100%;">
            <el-tab-pane
              key="flightList"
              v-permission="['tab_FlightConfig']"
              name="flightList"
              :label="$t('CargoMsg.Cargo_Flight')"
              :lazy="true"
            >
              <flight-list />
            </el-tab-pane>
            <el-tab-pane
              key="airTransitRoutingList"
              v-permission="['tab_AirTransitRoutingConfig']"
              name="airTransitRoutingList"
              :label="$t('queryJob.line')"
              :lazy="true"
            >
              <air-transit-routing-list />
            </el-tab-pane>
            <el-tab-pane key="airRegionList" v-permission="['tab_AirRegion']" name="airRegionList" :label="$t('queryJob.airTransportArea')" :lazy="true">
              <air-region-list />
            </el-tab-pane>
            <el-tab-pane
              key="airRouteList"
              v-permission="['tab_AirRoute']"
              name="airRouteList"
              :label="$t('CargoMsg.Cargo_Airline')"
              :lazy="true"
            >
              <air-route-list />
            </el-tab-pane>
            <el-tab-pane
              key="operationResponsibilityList"
              v-permission="['tab_OperationResponsibility']"
              name="operationResponsibilityList"
              :label="$t('queryJob.operationalResponsibilities')"
              :lazy="true"
            >
              <operation-responsibility-list />
            </el-tab-pane>
            <el-tab-pane
              key="operationResponsibilityAssign"
              v-permission="['tab_OperationResponsibilityAssign']"
              name="operationResponsibilityAssign"
              :label="$t('queryJob.assignmentOfResponsibilities')"
              :lazy="true"
            >
              <operation-responsibility-assign />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flightList from '@/views/cargo/v0/AirExport/components/airConfig/tabs/flightList'
import airTransitRoutingList from '@/views/cargo/v0/AirExport/components/airConfig/tabs/airTransitRoutingList'
import airRegionList from '@/views/cargo/v0/AirExport/components/airConfig/tabs/airRegionList'
import airRouteList from '@/views/cargo/v0/AirExport/components/airConfig/tabs/airRouteList'
import operationResponsibilityList from '@/views/cargo/v0/AirExport/components/airConfig/tabs/operationResponsibilityList'
import operationResponsibilityAssign from '@/views/cargo/v0/AirExport/components/airConfig/tabs/operationResponsibilityAssign'

export default {
  name: 'FmAirConfig',
  components: { flightList, airTransitRoutingList, airRegionList, airRouteList, operationResponsibilityList, operationResponsibilityAssign },
  data() {
    return {
      activeTabName: ''
    }
  },
  mounted() {
    const firstPane = this.$refs['tabs'].panes[0]
    this.activeTabName = firstPane ? firstPane.name : ''
  }
}
</script>
